
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CardClient, CompanyClient } from '@/api'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
import FileUpload from 'vue-upload-component'
import request from '@/utils/request'

@Component({
  name: 'CardEditor',
  components: {
    FileUpload
  }
})
export default class extends BaseEditor {
  private companyClient : CompanyClient
  private companyList = [];
  public constructor() {
    super()
    this.client = new CardClient()
    this.companyClient = new CompanyClient()
    this.data = {
      companyId: null,
      card_id: null,
      card_number: null,
      password: null,
      username: null,
      state: null
    }
    this.rules = {
      password: [{ required: true, message: '密码不能为空', trigger: 'blur' },
        {
          pattern: /^\d{6}$/,
          message: '密码必须为6位数字组合'
        }],
      state: [{ required: true, message: '状态为必选项', trigger: 'blur' }]
    }
  }

  public async getData(id = -1) {
    await super.getData(id)
    await this.getCompanyList()
  }

  private async getCompanyList() {
    this.companyList = await this.companyClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          nickName: true
        },
        order: ['name']
      }
    })
  }

  public async reset() {
    this.data = {
      companyId: null,
      card_id: null,
      card_number: null,
      password: null,
      username: null,
      state: null
    }
  }

  protected generateData(): any {
    const data = _.pick(this.data, [
      'companyId',
      'password',
      'username',
      'state'
    ])
    return this.clearData(data)
  }
}
